import type { ReactNode } from "react";
import { Header } from "./Header";
import { Footer } from "./Footer";

interface AppLayoutProps {
  sidebar: ReactNode;
  children: ReactNode;
}

export function AppLayout({ sidebar, children }: AppLayoutProps) {
  return (
    <div className="min-h-screen flex flex-col pt-14 sm:pt-24">
      <Header />
      <div className="flex-1 flex">
        {/* Sidebar - hidden on mobile, shown on lg+ */}
        <aside className="hidden lg:flex lg:w-72 lg:flex-col lg:fixed lg:inset-y-0 lg:pt-24 lg:border-r lg:border-border lg:bg-background">
          <div className="flex-1 overflow-y-auto px-4 py-6">
            {sidebar}
          </div>
        </aside>

        {/* Main content area */}
        <div className="flex-1 min-w-0 lg:pl-72 flex flex-col">
          <main className="flex-1">
            <div className="max-w-4xl mx-auto px-4 py-6">
              {children}
            </div>
          </main>
          <Footer />
        </div>
      </div>
    </div>
  );
}
